import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  conversations: [],
  loading: false,
  error: null,
};

const getConvo = createAction("getAllConvoRequest");
const getConvoSuccess = createAction("getAllConvoSuccess");
const getConvoFailure = createAction("getAllConvoFailure");

export const chatReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getConvo, (state, action) => {
      state.loading = true;
    })
    .addCase(getConvoSuccess, (state, action) => {
      state.loading = false;
      state.conversations = action.payload;
    })
    .addCase(getConvoFailure, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
});
